export const allowedUsersArray = [
    'yotuo2003@gmail.com',
    'takyiotuo.to@gmail.com',
    'takyiotuo.to@gmail.com',
    'africanbullyregistry@gmail.com'
]

